<template>
  <div>
    <div ref="textEditor" class="text-editor"></div>
    <input type="hidden" :name="name" v-model="form.text"/>
  </div>
</template>

<script>
import Quill from 'quill';

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      textEditor: false,
      form: {
        text: this.text
      }
    }
  },
  mounted() {
    const textEditor = new Quill(this.$refs.textEditor, {
      modules: {
        toolbar: [
          [{ header: [2, 3, false] }],
          ['bold', 'italic', 'underline'],
          ['link'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'script': 'sub'}, { 'script': 'super' }],
        ]
      },
      theme: 'snow'
    });

    if (this.form.text && this.form.text.length) {
      textEditor.setContents(JSON.parse(this.form.text), 'silent');
    }

    textEditor.on('text-change', (delta, oldDelta, source) => {
      this.form.text = JSON.stringify(textEditor.getContents());
    });
  }
}
</script>

<style lang="css">
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.snow.css';

.text-editor {
  height: 500px;
}
</style>